<template>
  <ApolloQuery
    :query="
      (gql) => gql`
        query GetStoryContributionRoles {
          storyContributionRoles {
            id
            _id
          }
        }
      `
    "
    @error="snackbar = true"
    :update="(data) => data.storyContributionRoles"
    v-slot="{ result: { error, data }, isLoading }"
  >
    <v-select
      v-if="!isLoading"
      v-model="role"
      dense
      hide-details
      :items="getItems(data)"
      item-text="_id"
      item-value="id"
      outlined
      background-color="white"
      :persistent-placeholder="false"
      :placeholder="$t('storyHub.publishing.wizard.selectRole')"
    >
    </v-select>
    <v-select v-else disabled loading> </v-select>
    <v-snackbar v-model="snackbar" multi-line>
      {{ error }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </ApolloQuery>
</template>
<script>
export default {
  props: {
    value: String,
  },
  data() {
    return {
      snackbar: false,
      role: this.value,
      excludeSponsor: true,
    };
  },
  methods: {
    getItems(data) {
      let items = [];
      for (const item of data) {
        if (item._id != "Sponsor") {
          items.push(item);
        }
      }
      return items;
    },
  },

  watch: {
    role(newValue) {
      this.$emit("input", newValue);
    },
    value(newValue) {
      if (this.role != newValue) {
        this.role = newValue;
      }
    },
  },
};
</script>